import { Injectable, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { LoginData } from '../models/login.model';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthOperatorService {
  private apiUrl = environment.apiUrl;
  private ak = "msys3SKxkKCeE5XXRw2K3tmYM0ri9ayH7";

  public authenticated: EventEmitter<boolean> = new EventEmitter<boolean>();

  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  public login(email: String, passwd: String): Observable<LoginData> {
    return this.httpClient.post<LoginData>(
      `${this.apiUrl}/api/oauth/login`,
      {
        email: email,
        password: passwd
      },
      this.httpOptions
    )
  }

  public perfil(): Observable<LoginData>{
    return this.httpClient.get<LoginData>(
      `${this.apiUrl}/api/oauth/me`,
      this.httpOptions
    );
  }

  public logUserIn(login: LoginData) {
    localStorage.setItem(this.ak, JSON.stringify({
      at: btoa(login.access_token),
      tt: btoa(login.token_type),
      op: btoa(JSON.stringify(login.user))
    }));
    this.authenticated.emit(true);
  }

  public logout() {
    localStorage.removeItem(this.ak);
    this.authenticated.emit(false);
  }

  public get isLoggedIn() : boolean {
    return localStorage.getItem(this.ak) !== null
  }

  public get tokenData() : string {
    return this.storageInfo.token_type + " " + this.storageInfo.access_token
  }

  public get user(): User {
    return this.storageInfo.user;
  }

  private get storageInfo(): any {
    const storage = localStorage.getItem(this.ak);
    const storageJSON = JSON.parse(storage);

    if(!storageJSON) {
      return {
        access_token: '',
        token_type: '',
        user: {},
      }
    }

    return {
      access_token: atob(storageJSON.at),
      token_type: atob(storageJSON.tt),
      user: JSON.parse(atob(storageJSON.op)),
    }
  }
}
